import { Logo } from "@/components/Logo";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { rupiah } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Loader2, Sparkles, Target, Rocket, MapPin, Phone, Mail, Users, Landmark } from "lucide-react";

export default function About() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-orange-500" /></div>;

  return (
    <div className="space-y-6 animate-float-in max-w-4xl">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-orange-500 via-amber-500 to-orange-400 p-8 sm:p-12 text-white">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 15% 25%, white 2px, transparent 2px), radial-gradient(circle at 75% 70%, white 3px, transparent 3px)", backgroundSize: "70px 70px" }} />
        <div className="relative z-10">
          <img src="/mascot.png" alt="Maskot" className="w-24 h-24 object-contain mb-5 drop-shadow-lg" />
          <h1 className="font-display text-4xl sm:text-5xl font-bold">{s.name}</h1>
          <p className="text-white/90 text-lg mt-2">{s.tagline}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="p-6 rounded-2xl border-amber-100">
          <div className="flex items-center gap-2 mb-3"><Target className="w-5 h-5 text-sky-500" /><h3 className="font-display text-xl font-bold">Visi</h3></div>
          <p className="text-slate-600">{s.vision}</p>
        </Card>
        <Card className="p-6 rounded-2xl border-amber-100">
          <div className="flex items-center gap-2 mb-3"><Rocket className="w-5 h-5 text-violet-500" /><h3 className="font-display text-xl font-bold">Misi</h3></div>
          <p className="text-slate-600">{s.mission}</p>
        </Card>
      </div>

      <Card className="p-6 rounded-2xl border-amber-100">
        <div className="flex items-center gap-2 mb-4"><Users className="w-5 h-5 text-orange-500" /><h3 className="font-display text-xl font-bold">Tim Pengajar</h3></div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {(s.teachers || []).map((t, i) => (
            <div key={i} className="p-4 rounded-xl bg-amber-50 text-center">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center text-white font-display font-bold text-lg mx-auto mb-2">{(t.name || "?").charAt(0)}</div>
              <div className="font-semibold text-slate-900">{t.name}</div>
              <div className="text-xs text-slate-500">{t.role}</div>
            </div>
          ))}
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="p-6 rounded-2xl border-amber-100 space-y-3">
          <h3 className="font-display text-xl font-bold mb-1">Kontak</h3>
          <div className="flex items-center gap-3 text-slate-600"><MapPin className="w-4 h-4 text-orange-500" /> {s.address}</div>
          <div className="flex items-center gap-3 text-slate-600"><Phone className="w-4 h-4 text-orange-500" /> {s.phone}</div>
          <div className="flex items-center gap-3 text-slate-600"><Mail className="w-4 h-4 text-orange-500" /> {s.email}</div>
        </Card>
        <Card className="p-6 rounded-2xl border-emerald-100 bg-emerald-50/40 space-y-2">
          <div className="flex items-center gap-2 mb-1"><Landmark className="w-5 h-5 text-emerald-600" /><h3 className="font-display text-xl font-bold">Pembayaran</h3></div>
          <div className="text-slate-600">Iuran: <span className="font-bold text-slate-900">{rupiah(s.monthly_fee)}</span> / bulan</div>
          <div className="text-slate-600">Jatuh tempo: tanggal <span className="font-bold">{s.due_day}</span></div>
          <div className="text-slate-600 pt-2 border-t border-emerald-200 mt-2">{s.bank_name}<br /><span className="font-bold text-slate-900">{s.bank_account}</span><br />a.n. {s.bank_holder}</div>
        </Card>
      </div>
    </div>
  );
}
